/* ==========================================================================
   Site Scripts
   --------------------------------------------------------------------------
   Handles device detection, layout utilities, and smooth scrolling.
   Depends on jQuery and matchHeight.
   ========================================================================== */

(function ($) {

  // ============================================================
  // Device Detection
  // ============================================================
  const ua = navigator.userAgent;
  const $html = $('html');

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    $html.addClass('is--device');
    if (/iPad/i.test(ua)) $html.addClass('is--ipad');
  } else {
    $html.addClass('not--device');
  }

  // ============================================================
  // Document Ready
  // ============================================================
  $(function () {

    // ============================================================
    // MatchHeight
    // ============================================================
    if ($('.same-height').length) {
      $('.same-height').matchHeight();
    }

    // ============================================================
    // Register GSAP Plugins
    // ============================================================
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


    // SVG BarAnimation
    const animateLine = document.querySelectorAll(".line-color-block");

    console.log(animateLine.length);
    const lineTL = gsap.timeline();
    
    // In Animation
    lineTL.to(animateLine, {
    	stagger: 0.15,
    	y: 0,
    	delay: -1,
    	// ease: "power2.inOut",
    	ease: "power3.inOut",
    	duration: 1.75,
    });

    // ============================================================
    // GSAP Smooth Scroll + Scroll Spy + Section Animations
    // ============================================================
    const scrollPadding = 66;

    // ----------------------------------------------
    // Scroll Restoration Fix
    // ----------------------------------------------
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // ----------------------------------------------
    // Smooth Anchor Scroll
    // ----------------------------------------------
    document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(link => {
      link.addEventListener('click', e => {
        const target = document.querySelector(link.hash);
        const samePath = location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '');
        const sameHost = location.hostname === link.hostname;

        if (target && samePath && sameHost) {
          e.preventDefault();

          gsap.to(window, {
            duration: 1,
            scrollTo: { y: target, offsetY: scrollPadding },
            ease: 'power2.out'
          });

          history.pushState(null, '', link.hash);
        }
      });
    });

    // Scroll to hash on page load
    window.addEventListener('load', () => {
      const hash = window.location.hash;
      if (hash) {
        const target = document.querySelector(hash);
        if (target) {
          gsap.to(window, {
            duration: 0.8,
            scrollTo: { y: target, offsetY: scrollPadding },
            ease: 'power1.out',
            delay: 0.25
          });
        }
      }
    });

    // ----------------------------------------------
    // Scroll Spy (Active Nav Highlight)
    // ----------------------------------------------
    const navLinks = document.querySelectorAll('nav a[href*="#"]:not([href="#"])');

    function setActive(link) {
      navLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');
    }

    navLinks.forEach(link => {
      const target = document.querySelector(link.hash);
      if (target) {
        ScrollTrigger.create({
          trigger: target,
          start: 'top center',
          end: 'bottom center',
          onEnter: () => setActive(link),
          onEnterBack: () => setActive(link),
        });
      }
    });

    // ----------------------------------------------
    // Section Animations (Fade + Slide In)
    // ----------------------------------------------
    // Add the class .reveal-section to any element you want to animate.
    gsap.utils.toArray('.reveal-section').forEach(section => {
      gsap.from(section, {
        y: 50,
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 85%', // animate when 85% of viewport height reached
          toggleActions: 'play none none reverse'
        }
      });
    });
	});
})(jQuery);